const BLOCK_ROOT_SELECTOR = '[data-featured-tabs]';
const TABLIST_SELECTOR = '[role="tablist"]';
const PANEL_MIN_HEIGHT_CSS_VAR = '--media-featured-text-panels-min-height';

function updatePanelsMinHeight(root, panels) {
  let maxHeight = 0;

  panels.forEach((panelElement) => {
    const wasHidden = panelElement.hasAttribute('hidden');

    if (wasHidden) {
      panelElement.removeAttribute('hidden');
    }

    const prevPosition = panelElement.style.position;
    const prevVisibility = panelElement.style.visibility;
    const prevPointerEvents = panelElement.style.pointerEvents;
    const prevInset = panelElement.style.inset;

    /* eslint-disable no-param-reassign */
    panelElement.style.position = 'absolute';
    panelElement.style.visibility = 'hidden';
    panelElement.style.pointerEvents = 'none';
    panelElement.style.inset = '0 auto auto 0';

    maxHeight = Math.max(maxHeight, panelElement.offsetHeight);

    panelElement.style.position = prevPosition;
    panelElement.style.visibility = prevVisibility;
    panelElement.style.pointerEvents = prevPointerEvents;
    panelElement.style.inset = prevInset;
    /* eslint-enable no-param-reassign */

    if (wasHidden) {
      panelElement.setAttribute('hidden', '');
    }
  });

  root.style.setProperty(PANEL_MIN_HEIGHT_CSS_VAR, `${maxHeight}px`);
}

function initFeaturedTextTabs(root) {
  if (root.getAttribute('data-featured-tabs-init') === '1') {
    return;
  }

  const tablist = root.querySelector(TABLIST_SELECTOR);

  if (!tablist) {
    return;
  }

  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
  const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
  const mediaPanels = Array.from(root.querySelectorAll('[data-featured-tab-media]'));

  if (tabs.length < 2 || panels.length < 2 || tabs.length !== panels.length) {
    return;
  }

  root.setAttribute('data-featured-tabs-init', '1');
  const updateMinHeight = () => updatePanelsMinHeight(root, panels);

  const activate = (index) => {
    tabs.forEach((tabElement, i) => {
      const selected = i === index;
      tabElement.setAttribute('aria-selected', selected ? 'true' : 'false');
      if (selected) {
        tabElement.setAttribute('tabindex', '0');
      } else {
        tabElement.setAttribute('tabindex', '-1');
      }
      tabElement.classList.toggle('media-featured-text__tabs-item--active', selected);
    });

    panels.forEach((panelElement, i) => {
      if (i === index) {
        panelElement.removeAttribute('hidden');
      } else {
        panelElement.setAttribute('hidden', '');
      }
    });

    if (mediaPanels.length === panels.length) {
      mediaPanels.forEach((mediaElement, i) => {
        if (i === index) {
          mediaElement.removeAttribute('hidden');
        } else {
          mediaElement.setAttribute('hidden', '');
        }
      });
    }

    updateMinHeight();
  };

  updateMinHeight();

  tabs.forEach((tabElement, index) => {
    tabElement.addEventListener('click', () => {
      activate(index);
    });

    tabElement.addEventListener('keydown', (event) => {
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex !== null) {
        event.preventDefault();
        activate(nextIndex);
        tabs[nextIndex].focus();
      }
    });
  });

  window.addEventListener('load', updateMinHeight, { once: true });
  window.addEventListener('resize', updateMinHeight);
}

function initAllFeaturedTextTabs() {
  document.querySelectorAll(BLOCK_ROOT_SELECTOR).forEach((root) => {
    initFeaturedTextTabs(root);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllFeaturedTextTabs();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/media-featured-text-updated', () => {
      document.querySelectorAll(BLOCK_ROOT_SELECTOR).forEach((blockRoot) => {
        blockRoot.removeAttribute('data-featured-tabs-init');
      });
      initAllFeaturedTextTabs();
    });
  }
});
